module.exports = __webpack_public_path__ + "static/media/hero-image.48f5716e.png";